import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  currentName: 'none',
  isHelpTriggered: false,
};

const VoReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_CURRENT_VO_NAME:
      return {
        ...state,
        currentName: payload,
      };

    case REDUX_ACTIONS.SUBMIT_SUPERLATIVE:
    case REDUX_ACTIONS.SELECT_DOCUMENT:
    case REDUX_ACTIONS.INCREMENT_WRONG_COUNT:
    case REDUX_ACTIONS.SELECT_CHARACTER:
    case REDUX_ACTIONS.DESELECT_CHARACTER:
    case REDUX_ACTIONS.CHANGE_SCREEN:
    case REDUX_ACTIONS.STOP_VO_PLAYBACK:
      return {
        ...state,
        currentName: 'none',
      };

    case REDUX_ACTIONS.TRIGGER_HELP_VO:
      return {
        ...state,
        isHelpTriggered: true,
      };

    case REDUX_ACTIONS.ON_VO_ENDS:
      return {
        ...state,
        isHelpTriggered: false,
      };

    default:
      return state;
  }
};

export default VoReducer;
